







































































































































































































import Vue from 'vue';
import { Howl } from 'howler';
import firebase from 'firebase';
import DetectRTC from 'detectrtc';
import LearningTools from '@/tools/learning';
import UserTools from '@/tools/user';
import { FirebaseLesson, Lang } from '@/store/types';
import RoutePaths from '@/router/route_paths';
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import MyStats from '@/components/app/MyStats.vue';
import Bookmarks from '@/components/ui/Bookmarks.vue';
import MyAccount from '@/components/ui/MyAccount.vue';
import MyCourses from '@/components/ui/MyCourses.vue';
import History from '@/components/ui/History.vue';
import MobileLinksPopup from '@/components/ui/MobileLinksPopup.vue';
import DevelopmentPopup from '@/components/ui/DevelopmentPopup.vue';
import { version } from '@/../package.json';
import BbTools from '@/tools/bluebird';

require('firebase/auth');

export default Vue.extend({
  name: 'BbApp',
  components: {
    breadcrumbs: Breadcrumbs,
    'my-stats': MyStats,
    bookmarks: Bookmarks,
    'my-courses': MyCourses,
    'my-account': MyAccount,
    'mobile-links-popup': MobileLinksPopup,
    'development-popup': DevelopmentPopup,
    history: History,
  },
  data() {
    return {
      appVersion: '',
      langI: this.$store.state.langI,
      myStatsDialog: false,
      accountDialog: false,
    };
  },
  computed: {
    routerKey(): string {
      let result = 'key';
      if (this.$route.path === RoutePaths.LEVELS) {
        result += this.$store.state.langL ? this.$store.state.langL.id : '';
      }
      if (this.$route.path === RoutePaths.LESSONS) {
        result += this.$store.state.unit ? this.$store.state.unit.unit : '';
      }
      if (this.$route.path === RoutePaths.AUDIO) {
        result += this.$store.state.lesson ? this.$store.state.lesson.id : '';
      }
      return result;
    },
  },
  created() {
    this.appVersion = version;
    if (!Vue.prototype.$beepPlayer || !Vue.prototype.$donePlayer || !Vue.prototype.$greenPlayer
      || !Vue.prototype.$yellowPlayer || !Vue.prototype.$redPlayer) {
      Vue.prototype.$beepPlayer = new Howl({
        src: ['audio/beep.mp3'],
        preload: true,
        autoplay: false,
        volume: this.$store.getters.effectsVolume,
      });
      Vue.prototype.$donePlayer = new Howl({
        src: ['audio/quiz_end.mp3'],
        preload: true,
        autoplay: false,
        volume: this.$store.getters.effectsVolume,
      });
      Vue.prototype.$greenPlayer = new Howl({
        src: ['audio/green.mp3'],
        preload: true,
        autoplay: false,
        volume: this.$store.getters.effectsVolume,
      });
      Vue.prototype.$yellowPlayer = new Howl({
        src: ['audio/yellow.mp3'],
        preload: true,
        autoplay: false,
        volume: this.$store.getters.effectsVolume,
      });
      Vue.prototype.$redPlayer = new Howl({
        src: ['audio/red.mp3'],
        preload: true,
        autoplay: false,
        volume: this.$store.getters.effectsVolume,
      });
    }
    const drtc: any = DetectRTC;
    drtc.load(() => {
      let { osName } = drtc;
      const iOSPlatform = navigator.platform && navigator.platform.match(/iPhone|iPod|iPad/);
      if (iOSPlatform) {
        osName = 'iOS';
      }
      // detect if mobile Safari requests desktop mode
      if (osName.match(/Mac OS/) && this.$store.state.windowWidth < 1300) {
        osName = 'iOS';
      }
      this.$store.commit('setOsName', osName);
    });
  },
  methods: {
    onLogout(): void {
      firebase.auth().signOut().then(() => {
        UserTools.logoutUser(this.$store, this.$router);
      }).catch((error: Error) => {
        this.$store.commit('setAlertMessage', {
          text: 'Sign out error',
          error,
        });
      });
    },
    async onLangIChanged(langI: Lang): Promise<void> {
      this.$store.commit('setMainLoading', true);
      await LearningTools.setNewLangIL(this.$store, langI.id, null);
      if (this.$route.path !== RoutePaths.WELCOME) {
        this.$router.push(RoutePaths.WELCOME);
      }
      // this.$store.commit('setMainLoading', false);
    },
    onStats(): void {
      this.myStatsDialog = true;
    },
    onAccount(): void {
      this.accountDialog = true;
    },
    onBookmark(lesson: FirebaseLesson): void {
      LearningTools.loadLesson(this.$store, this.$router, lesson);
    },
    onHistory(lesson: FirebaseLesson): void {
      LearningTools.loadLesson(this.$store, this.$router, lesson, true);
    },
    async onMyCourse(item: Lang): Promise<void> {
      this.$store.commit('setMainLoading', true);
      this.$store.commit('setLesson', null);
      this.$store.commit('setLessons', []);
      this.$store.commit('setUnit', null);
      this.$store.commit('setUnits', []);
      this.$store.commit('setLevel', null);
      this.$store.commit('setLevels', null);
      this.$store.commit('setLevelsPersonalized', []);
      this.$store.commit('setPersonalizedCourse', null);
      await LearningTools.setNewLangIL(this.$store, this.$store.state.langI.id, item.id);
      if (this.$route.path !== RoutePaths.LEVELS) {
        this.$router.push(RoutePaths.LEVELS);
      }
    },
    onHelp(): void {
      window.open(BbTools.WEB_LINK_HELP, '_blank');
    },
    onEmailSupport(): void {
      const emailLink = `${BbTools.WEB_LINK_EMAIL}?subject=Support&body=`;
      let emailBody = `Bluebird web.\nApp version: ${version}\n`;
      emailBody += `Interface Language: ${this.$store.state.langI.lang}\n`;
      emailBody += `Learning Language: ${this.$store.state.langL.text}\n`;
      if (this.$store.getters.isPremiumUser) {
        emailBody += `Timestamp: ${new Date().getTime()}\n`;
      }
      if (this.$store.state.lastVisitedPhraseForEmail) {
        emailBody += `Lesson: ${this.$store.state.lastVisitedPhraseForEmail.lesson}\n`;
        emailBody += `Screen: ${this.$store.state.lastVisitedPhraseForEmail.screen}\n`;
        emailBody += `Phrase: ${this.$store.state.lastVisitedPhraseForEmail.id} (${this.$store.state.lastVisitedPhraseForEmail.word})\n`;
      }
      emailBody += `\n\n${this.$store.state.tr.DescribeProblem}\n`;
      window.open(emailLink + encodeURIComponent(emailBody), '_blank');
    },
    onTwitter(): void {
      window.open(BbTools.WEB_LINK_TWITTER, '_blank');
    },
  },
});

